import Tables from 'src/class/Tables';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 100,
      sortable: true,
    },
    {
      prop: 'cause_rejected_category.name',
      label: i18n.t('common_words.associated_category'),
      minWidth: 100,
      sortable: true,
      formatter: (row) => {
        return row.cause_rejected_category ?
            `${row.cause_rejected_category.name}`
            : 'N/A';
      },
    },
  ];

  return { Table };
};

export default configTable;
